<template>
  <div>
    <a v-if="isHyperlinkActive === true" class="tw-whitespace-nowrap tw-text-primary" :href="`tel:${value}`">{{ labelNationalFormat }}</a>
    <div v-else class="tw-whitespace-nowrap">{{ labelNationalFormat }}</div>
  </div>
</template>

<script>
const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();
const textFormatter = require("google-libphonenumber").PhoneNumberFormat;

export default {
  name: "BasePhoneNumberField",
  props: {
    value: String,
    isHyperlinkActive: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    labelRegionCode() {
      return this.value ? phoneUtil.getRegionCodeForNumber(phoneUtil.parseAndKeepRawInput(this.value)) : "US";
    },
    parsedlabelPhoneNumber() {
      return this.value ? phoneUtil.parseAndKeepRawInput(this.value, this.labelRegionCode) : null;
    },
    labelNationalFormat() {
      return this.value ? phoneUtil.format(this.parsedlabelPhoneNumber, textFormatter.NATIONAL) : "";
    },
  },
};
</script>
